import NewsFormCalendar from './NewsFormCalendar';

export default NewsFormCalendar;
